import {
    HttpResponse,
    ShareLogModel,
    RequestParams,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery} from '@/libs/core/crud/crud-query';
import {CrudService, CrudListResponse, CrudResponse} from '@/libs/core/crud/crud-service';

export class ShareLogsDataService implements CrudService<ShareLogModel, ShareLogModel> {
    
    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        throw new Error("Method not implemented.");
    }
    
    getGrouped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getShareLogGroupped(query, params);
    }
    
    getAll(query: CrudDataQuery<ShareLogModel>): Promise<CrudListResponse<ShareLogModel>> {
        return ApiService.api.getShareLogBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<ShareLogModel>> {
        return ApiService.api.getShareLogById(id, params);
    }

    create(item: ShareLogModel, params?: RequestParams): Promise<CrudResponse<ShareLogModel>> {
        throw "NotImplemented";
    }

    update(item: ShareLogModel, params?: RequestParams): Promise<ShareLogModel> {
        throw "NotImplemented";
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<ShareLogModel> {
        throw "NotImplemented";
    }

    delete(query: CrudDataQuery<ShareLogModel>): Promise<CrudListResponse<ShareLogModel>> {
        throw "NotImplemented";
    }

    download(query: CrudDataQuery<ShareLogModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        return ApiService.api.exportShareLogBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

}
